import type { Zone, Faction } from '@dissidium/contracts';

export const SCAFFOLD = {
  version: 1,
  source: { document: 'docs/world/03-geography.md', section: 'Regional movement graph' },
  zones: [
    ['Z01', 'Caldris, the Divided Forum', 90, 118, 'SEN'], ['Z02', 'Nacre Quay', 84, 20, 'SAL'],
    ['Z03', 'The Silt Stair', 108, 86, 'REE'], ['Z04', 'The Quiet Kilns', 115, 89, 'REE'],
    ['Z05', 'Vannic Saltpans', 33, 31, 'SAL'], ['Z06', 'The Broken Causeway', 49, 112, 'SAL'],
    ['Z07', 'Neral Gate', 113, 210, 'BRZ'], ['Z08', 'Eshmar Intake', 175, 132, 'REE'],
    ['Z09', 'The Threefold Terrace', 88, 145, 'SEN'], ['Z10', 'Dovren Quarry', 35, 159, 'BRZ'],
    ['Z11', 'The Measure House', 112, 178, 'BRZ'], ['Z12', 'The Unfinished Road', 13, 108, 'SEN'],
  ] as readonly (readonly [Zone, string, number, number, Faction])[],
  links: [
    ['Z01', 'Z02', 112], ['Z01', 'Z03', 43], ['Z02', 'Z03', 76], ['Z03', 'Z04', 9],
    ['Z01', 'Z06', 44], ['Z06', 'Z12', 39], ['Z06', 'Z10', 57], ['Z01', 'Z09', 30],
    ['Z09', 'Z11', 45], ['Z11', 'Z07', 36], ['Z01', 'Z08', 94], ['Z03', 'Z08', 88], ['Z02', 'Z05', 56],
  ] as readonly (readonly [Zone, Zone, number])[],
  institutions: {
    SEN: { name: 'Continuance Senate', leverage: 'lawful-status register', leader: 'person:vessia-caldran', successor: 'person:oren-valt', motive: 'Preserve civic adjudication', fixedCulpability: 'Sale of 96 disputed debt bonds in 640 AC', min: 700, max: 1300 },
    BRZ: { name: 'Bronze Standard', leverage: 'trained detachment and functioning depot', leader: 'person:darven-soreth', successor: 'person:heleth-var', motive: 'Keep the army together and honour service claims', fixedCulpability: 'Authorised 17 hostages in 640 AC', min: 1800, max: 3200 },
    REE: { name: 'Reed Covenant', leverage: 'functional grain producer network', leader: 'person:isera-ven', successor: 'person:narel-oss', motive: 'Collective water supervision and protected subsistence', fixedCulpability: 'Permitted Red Tally seed seizure from four non-member villages', min: 900, max: 1700 },
    SAL: { name: 'Salt Compact', leverage: 'clearing house with external shipping intermediary', leader: 'person:maurel-neth', successor: 'person:sereth-vann', motive: 'Keep contracts and shipping viable', fixedCulpability: 'Authorised Vannic recovery contracts binding 143 people', min: 600, max: 1100 },
  },
};
export function pathBetween(start: Zone, end: Zone): Zone[] {
  const queue: Zone[][] = [[start]];
  const seen = new Set<Zone>([start]);
  for (const path of queue) {
    const tail = path.at(-1)!;
    if (tail === end) return path;
    const neighbors = SCAFFOLD.links.flatMap(([a, b]) => a === tail ? [b] : b === tail ? [a] : []).sort();
    for (const next of neighbors) if (!seen.has(next)) { seen.add(next); queue.push([...path, next]); }
  }
  throw new Error('The source graph has no route');
}
